/**
 *  Yotpo star rating buttons: start the accessible name with the visible
 *  text (e.g. "1 Review"), so speech control users can say what they see.
 *  Yotpo renders these after page load, so watch the DOM for them.
 */
(function () {
  const selector = '.yotpo-sr-bottom-line-button';

  function fixLabel(button) {
    const visible = button.innerText.replace(/\s+/g, ' ').trim();
    const label = button.getAttribute('aria-label') || '';
    if (!visible || button.dataset.a11yLabel === label) {
      return;
    }
    const rating = label.match(/([\d.]+) out (?:of )?5 stars/);
    const jump = /jump to reviews/i.test(label) ? ' Jump to reviews.' : '';
    const name = rating ? `${visible}, ${rating[1]} out of 5 stars.${jump}` : `${visible}. ${label}`;

    button.dataset.a11yLabel = name;
    button.setAttribute('aria-label', name);
  }

  function fixAll() {
    document.querySelectorAll(selector).forEach(fixLabel);
  }

  new MutationObserver(fixAll).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-label']
  });
  fixAll();
})();
